import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { ArbitrageDesinvestissableItem, ArbitrageInvestissableItem } from '@/api/placementApi.schemas';
import CardSupport from '@/components/CardSupport/CardSupport';
import { getCategoryColor } from '@/constants/categoryColors';
import useEqualizeCardHeights from '@/hooks/useEqualizeCardHeights';

import styles from './styles.module.css';

type ArbitrageSupport = ArbitrageInvestissableItem | ArbitrageDesinvestissableItem;

type ArbitrageCardsProps = {
  supports: ArbitrageSupport[];
  title: string;
  isInvested: boolean;

  getMontant: (support: ArbitrageSupport) => number | null;
};

const ArbitrageCards = ({ supports, title, isInvested, getMontant }: ArbitrageCardsProps) => {
  const { t } = useTranslation();
  const containerRef = useEqualizeCardHeights(supports.map((support) => support.label).join('|'));

  if (!supports.length) {
    return <p className={styles.noSupports}>{t('summaryArbitrage.noSupports')}</p>;
  }

  return (
    <section>
      <h3 className={styles.sectionTitle}>{title}</h3>
      <div ref={containerRef}>
        <MtxGrid row>
          {supports.map((support, index) => (
            <MtxGrid
              key={`${isInvested ? 'inv' : 'des'}-${support.codeIsin ?? support.codeSupport ?? support.label ?? String(index)}`}
              col={4}
              colXs={12}
              colSm={6}
              colMd={6}
              colLg={4}
            >
              <CardSupport
                badge={support.sousTypeFonds ?? ''}
                badgeColor={getCategoryColor(support.sousTypeFonds)}
                name={support.label ?? ''}
                isin={support.codeIsin ? `ISIN : ${support.codeIsin}` : ''}
                manager={support.gestionnaire ?? ''}
                montantDesinvesti={getMontant(support)}
                pourcentage={support.pourcentage ?? 0}
                noteRisque={support.srri ?? null}
                performances={{
                  ytd: support.perfYTD ?? null,
                  oneYear: support.perf12M ?? null,
                  threeYears: support.perf36M ?? null,
                  fiveYears: support.perf60M ?? null,
                }}
                isInvested={isInvested}
              />
            </MtxGrid>
          ))}
        </MtxGrid>
      </div>
    </section>
  );
};

export type { ArbitrageCardsProps, ArbitrageSupport };
export default ArbitrageCards;
